/* Official Apex Flow Digital social channels — single source of truth for the
 * /social hub AND the Organization `sameAs` entity graph (Social-Engine SOP).
 *
 * Brian: paste the real profile URLs here and they light up everywhere —
 * the /social follow buttons + the brand's sameAs on every page. An empty
 * `url` = not connected yet: it renders no button and is NOT emitted in
 * sameAs (an unreachable URL triggers Google's Misrepresentation flag, so we
 * never ship a placeholder). */

export type SocialChannel = {
  platform: string;
  label: string;
  /** "" until Brian pastes the real profile URL. */
  url: string;
};

export const SOCIAL_CHANNELS: SocialChannel[] = [
  { platform: "instagram", label: "Instagram", url: "" },
  { platform: "youtube", label: "YouTube", url: "" },
  { platform: "tiktok", label: "TikTok", url: "" },
  { platform: "x", label: "X (Twitter)", url: "" },
  { platform: "facebook", label: "Facebook", url: "" },
  { platform: "pinterest", label: "Pinterest", url: "" },
];

/** Channels with a real URL filled in — safe to link and to emit in schema. */
export const CONNECTED_CHANNELS = SOCIAL_CHANNELS.filter(
  (c) => c.url.trim().length > 0,
);

/** Real profile URLs only — safe to spread into Organization `sameAs`. */
export function socialSameAs(): string[] {
  return CONNECTED_CHANNELS.map((c) => c.url);
}
